import { useMyInfo } from 'shared/src/queries';
import { useGoodsCouponRedeemAll } from '../queries/useGoodsCouponRedeemAll';
import { useCallback } from 'react';
import { bridge, isNil } from 'shared/src/utils';
import { useSafeTimeout } from 'shared/src/hooks';
import { useLogCompleteDownloadCouponAll } from './useLogCompleteDownloadCouponAll';
import type { GoodsCoupon } from 'shared/src/api';
import { useLogDownloadCoupon } from './useLogDownloadCoupon';
import { useGoodsSno } from '../../../hooks/useGoodsSno';

export const useOnPressGoodsCouponRedeemAll = (coupons: GoodsCoupon[]) => {
  const { mutateAsync: redeemAllCoupon, isPending: loadingRedeemAllCoupon } =
    useGoodsCouponRedeemAll();
  const { data: myInfo } = useMyInfo();
  const logCompleteDownloadAll = useLogCompleteDownloadCouponAll();
  const logCompleteDownloadCoupon = useLogDownloadCoupon();
  const goodsSno = useGoodsSno();
  const setSafeTimeout = useSafeTimeout();

  return {
    loading: loadingRedeemAllCoupon,
    action: useCallback(async () => {
      if (!myInfo) return;
      if (myInfo.is_anonymous) {
        bridge.assertLogin({ redirect: `/goods/${goodsSno}` });
        setSafeTimeout(() => {
          bridge.toast('로그인이나 회원가입이 필요해요');
        }, 200);
        return;
      }
      if (isNil(myInfo.mobile)) {
        setSafeTimeout(() => {
          bridge.toast('쿠폰 발급을 위해서는 전화번호 등록이 필요합니다');
        }, 200);
        return;
      }

      try {
        const response = await redeemAllCoupon();
        logCompleteDownloadAll();

        // redeemed_coupons 미응답이면 구버전 서버로 보고 기존처럼 전체를 발급 완료 처리
        const redeemedCouponSnos = new Set(
          response.redeemed_coupons ?? coupons.map(coupon => coupon.sno),
        );

        coupons
          .filter(coupon => redeemedCouponSnos.has(coupon.sno))
          .forEach(coupon => {
            logCompleteDownloadCoupon({ coupon: coupon, isDownloadAll: true });
          });
      } catch (ex) {
        const error = ex as Error;
        bridge.toast(error.message);
      }
    }, [
      coupons,
      logCompleteDownloadAll,
      logCompleteDownloadCoupon,
      goodsSno,
      myInfo,
      redeemAllCoupon,
      setSafeTimeout,
    ]),
  };
};
